import styled from "styled-components";
import background from './image/ironing-g89c6a1ac9_1920.jpg';

export const HomeStyle = styled.section`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    width: 100%;
    height: 838px;
    background-color: #121214;
    color: white;
    background-image: url('${background}');
    background-repeat: no-repeat;
    background-size: cover;
    

    div {
        display: flex;
        align-items: center;
        flex-direction: column;
        & div {
            @media (max-width: 768px) {
                margin-left: 10px;
                width: 90vw;
            }
            & h3 {
                text-transform: uppercase;
                color: #202024;
                font-weight: bolder;
            }
            & p {
                color: #202024;
                font-size: clamp(0.9em, 0.9em + 1vw, 1.5em);
                text-align: center;
            }
            margin-top: 140px;
            background-color: white;
            width: 650px;
            padding: 10px;
            border-radius: 30px;
            border-color: transparent;
        }
    }

    img {
        width: 250px;
        height: 250px;
        border-radius: 200px;
    }
`